import { render } from "./LocationList2.vue?vue&type=template&id=0c9b7c52&scoped=true"
import script from "./LocationList2.vue?vue&type=script&lang=js"
export * from "./LocationList2.vue?vue&type=script&lang=js"

import "./LocationList2.vue?vue&type=style&index=0&id=0c9b7c52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c9b7c52"]])

export default __exports__